import {
  CustodianDoc,
  CustodianWhole,
} from 'lib/interfaces/database/custodian';
import _ from 'lodash';
import { CustodiansService } from 'services/custodians';
import { create } from 'zustand';

interface State {
  data: CustodianWhole[];
}

interface Actions {
  readonly load: (force?: boolean) => void;
  readonly create: (v: Partial<CustodianDoc>) => Promise<boolean>;
  readonly update: (id: string, v: Partial<CustodianDoc>) => Promise<boolean>;
}

interface Store extends State, Actions {}

const useCustodiansStore = create<Store>((set, get) => {
  const service = CustodiansService.getInstance();

  return {
    data: [],

    load: async (force) => {
      if (!force && get().data.length > 0) {
        console.debug('Skipped unforced load');
        return;
      }

      const results = await service.search({});

      if (results) {
        set({ data: results });
      }
    },

    create: async (v) => {
      const record = await service.create(v);

      if (record) {
        const nextData = _.clone(get().data);
        nextData.push(record);

        set({ data: nextData });
      }

      return !!record;
    },

    update: async (id, v) => {
      const record = await service.update(id, v);

      if (record) {
        const nextData = get().data.map((d) =>
          d.id === record.id ? record : d
        );

        set({ data: nextData });
      }

      return !!record;
    },
  };
});

export default useCustodiansStore;
